var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0811 60.8103H3.91895C3.36666 60.8103 2.91895 60.3626 2.91895 59.8103V14.6211C2.91895 14.0688 3.36666 13.6211 3.91895 13.6211H25.8357C26.1129 13.6211 26.3777 13.7361 26.5668 13.9388L32.7846 20.6007C32.9737 20.8033 33.2385 20.9184 33.5157 20.9184H60.2973C60.8496 20.9184 61.2973 21.3661 61.2973 21.9184V33.567",
    stroke: "#56595B",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9647 33.4416C45.9647 35.1374 44.59 36.5121 42.8942 36.5121C41.1984 36.5121 39.8237 35.1374 39.8237 33.4416C39.8237 31.7458 41.1984 30.3711 42.8942 30.3711C44.59 30.3711 45.9647 31.7458 45.9647 33.4416Z",
    fill: "#56595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2974 61.7842V40.8652",
    stroke: "#56595B",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0269 48.1465L61.2828 39.8905L69.5388 48.1465",
    stroke: "#56595B",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63086 52.2261L20.9243 35.0312L29.2821 45.471L35.026 38.431L46.2217 52.2261",
    stroke: "#56595B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageUpload);
export default __webpack_public_path__ + "static/media/icon-image-upload.e0d5fc3c97211538ea6968bb36f0fbce.svg";
export { ForwardRef as ReactComponent };